import { getStore } from "../store/store";

export function isCalendarSchedulingDialogOpen(): boolean {
    return getStore().isOpen;
}
